import { DownloadOutlined, LoadingOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Col, Input, Row, Spin, Table } from 'antd';
import Column from 'antd/es/table/Column';
import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from "react-redux";
import { toast } from 'react-toastify';
import { arrayCommon, formatVND } from '../../helpers/common';
import { ChiTietBaoHiem } from '../../models/baohiem/BaoHiem';
import { thongTinNhanSuTinhBaoHiem } from '../../services/baohiem';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';

const NhanSuNopBaoHiemTableModal = ({ id, hide, isQuanLy, onSubmit }: { id: number, isQuanLy: boolean, hide: () => void, onSubmit: (data: any) => void }) => {    
    const [loading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [data, setData] = useState<Array<ChiTietBaoHiem>>([]);
    const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;    

    const [selectedItems, setSelectedItems] = useState<Array<any>>([]);
    const dispatch = useDispatch();
    const layDuLieu = async (id: number) => {
        dispatch(showLoadingScreen())
        setLoading(true);
        try {
            var rs = await thongTinNhanSuTinhBaoHiem(id);
            setData(rs.filter(item => item.isQuanLy == isQuanLy));
        } catch (error: any) {
            toast.error(error);
        }
        setLoading(false);
        dispatch(hideLoadingScreen());
    };
    useEffect(() => {
            layDuLieu(id);
    }, [id]);
    return (
        <section>
            <Modal show={true} onHide={hide} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Danh sách nhân viên</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loading ?
                        <div className='text-center'><Spin indicator={antIcon} /></div> :
                        <>
                            <Row className="form-group">
                                <Col span={12}>
                                    <Input prefix={<SearchOutlined />} placeholder="Nhập tên nhân viên để tìm kiếm..." onChange={(e) => setSearchText(e.target.value)} />
                                </Col>
                                <Col span={12}>
                                    <Button type="primary" className="float-right" onClick={() => {
                                        hide();
                                        onSubmit(selectedItems);
                                    }} icon={<DownloadOutlined />}>
                                        Tính BHXH
                                    </Button>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <Table
                                        locale={{ emptyText: "Không có dữ liệu" }}
                                        dataSource={data.map((item: any, index) => { item.key = index; return item; }).filter((record: ChiTietBaoHiem) =>
                                            record.hoTen.toLowerCase().includes(searchText.toLowerCase())
                                        )}
                                        pagination={false}
                                    >
                                        <Column
                                            title="STT"
                                            key="STT"
                                            render={(value, record, index) =>
                                            (
                                                <>
                                                    {index + 1}
                                                </>
                                            )
                                            }
                                        />
                                        <Column title="Tên nhân viên" dataIndex="hoTen" key="hoTen" />
                                        <Column title="Chức vụ" dataIndex="chucVu" key="chucVu" />
                                        <Column title="Mức đóng BHXH" key="mucLuongDongBaoHiem"
                                            render={(value, record, index) =>
                                            (
                                                <>
                                                    {formatVND(value?.mucLuongDongBaoHiem)}
                                                </>
                                            )
                                            }
                                        />
                                        <Column
                                            key="choose"
                                            title= "Chọn"
                                            render={(value: ChiTietBaoHiem, record, index) =>
                                            (
                                                <div className='text-center' key={value.id}>
                                                    <input type="checkbox"
                                                        data-index={value?.id}
                                                        checked={selectedItems.map(x => x.idNhanVien).includes(value?.idNhanVien) ? true : false}
                                                        onChange={(e) => {
                                                            var isChecked = e.target.checked;
                                                            var tempItems = [...selectedItems];
                                                            var isExists = arrayCommon.isExisted(selectedItems.map(x => x.idNhanVien), value.idNhanVien);
                                                            if (isChecked && !isExists) {
                                                                tempItems.push(value);
                                                            }
                                                            if (!isChecked && isExists) {
                                                                var index = tempItems.map(x => x.idNhanVien).indexOf(value.idNhanVien);
                                                                if (index > -1) {
                                                                    tempItems.splice(index, 1);
                                                                }
                                                            }
                                                            setSelectedItems(tempItems);
                                                        }}
                                                    />
                                                </div>
                                            )
                                            }
                                        />
                                    </Table>
                                </Col>
                            </Row>
                        </>
                    }
                </Modal.Body>
            </Modal >
        </section>
    );
};
export default NhanSuNopBaoHiemTableModal;
